import { EquipmentCreate, EquipmentPatch, EquipmentResponse } from '@siteday/shared';
import { type z } from 'zod';

import { api } from './client';
import { listOf } from './list';

export type EquipmentFilters = { active?: string | undefined };

export const listEquipment = (filters: EquipmentFilters = {}) =>
  api.get('/equipment', listOf(EquipmentResponse), { active: filters.active });

export const createEquipment = (input: z.input<typeof EquipmentCreate>) =>
  api.post('/equipment', EquipmentCreate.parse(input), EquipmentResponse);

export const patchEquipment = (id: string, patch: z.input<typeof EquipmentPatch>) =>
  api.patch(`/equipment/${id}`, EquipmentPatch.parse(patch), EquipmentResponse);
